module.exports = __webpack_public_path__ + "img/gyhd.82603976.png";